import LeftArrowIcon from '@images/icons/left-arrow-icon.svg?react'
import AddExpenseButton from '@views/expenseManagement/@elements/AddExpenseButton'
import { paths, useGetReportQuery } from 'mmfintech-backend-api'
import { useHistory } from 'react-router-dom'
import { ReportHeaderButtons } from './ReportHeaderButtons'
import { ReportTitle } from './ReportTitle'

import './reportHeader.scss'

export const ReportHeader = ({ param }) => {
  const history = useHistory()

  const { data } = useGetReportQuery({ reportId: param }, { skip: !param })

  return !data ? null : (
    <div className='report-header-container'>
      <div className='left-wrapper'>
        <div
          onClick={e => {
            e?.preventDefault()
            history.push(paths.expenseManagement.dashboard())
          }}
          className='back-arrow-icon'
        >
          <LeftArrowIcon />
        </div>
        <ReportTitle report={data} />
      </div>
      <div className='right-wrapper'>
        <AddExpenseButton reportId={param} />
        <ReportHeaderButtons reportId={param} />
      </div>
    </div>
  )
}
